const isNull = (a) => a === null;
export default isNull;
